<template>
    <div class="dropdown float-left">
        <button type="button" :disabled="spectrumLoading"
                class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                id="spectrumOptionDropDown" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
            <i v-if="spectrumLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
            Spectrum Options <i class="fa fa-caret-down mx-1"></i>
        </button>
        <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="spectrumOptionDropDown">
            <button v-if="canErpCreate" type="button" class="dropdown-item py-2" :disabled="spectrumCompanyMapping.direction === 'one-way-followup' || company.spectrum_customer_id" @click.prevent.stop="syncSpectrumCompany">
                Connect/Push to Spectrum
            </button>
            <button v-if="canErpUpdate" type="button" class="dropdown-item py-2"  :disabled="spectrumCompanyMapping.direction === 'one-way-followup' || !company.spectrum_customer_id" @click.prevent.stop="connectCustomerToSpectrum">
                Update Customer on Spectrum
            </button>
            <button v-if="canErpUpdate" type="button" class="dropdown-item py-2" :disabled="spectrumCompanyMapping.direction === 'one-way-followup' || !company.spectrum_customer_id" @click.prevent.stop="pushOtherContactToSpectrum">
                Push another Contact
            </button>
            <button v-if="canErpSync" type="button" class="dropdown-item py-2" :disabled="spectrumCompanyMapping.direction === 'one-way-third-party'" @click.prevent="openModal('syncSpectrumCustomerModal')">
                Sync from Spectrum
            </button>
        </div>

        <div class="modal fade" id="spectrumTaxCodeSelectionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Select Spectrum Tax Code</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('spectrumTaxCodeSelectionModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="spectrumTaxCodes.length > 0 && spectrumTermsCodes.length > 0">
                            <div class="row container">
                                <label class="mb-0">Select Tax Code</label>
                                <multiselect
                                    id="selectSpectrumTaxCode"
                                    v-model="selectedTaxCode"
                                    :options="spectrumTaxCodes"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    :taggable="false"
                                    open-direction="below"
                                    placeholder="Pick a tax code"
                                    :showLabels="false"
                                    label="description"
                                    track-by="id"
                                    :preselect-first="false"
                                >
                                </multiselect>
                            </div>
                            <div class="row container mt-2">
                                <label class="mb-0">Select Terms Code</label>
                                <multiselect
                                    id="selectSpectrumTermsCode"
                                    v-model="selectedTermsCode"
                                    :options="spectrumTermsCodes"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    :taggable="false"
                                    open-direction="below"
                                    placeholder="Pick terms code"
                                    :showLabels="false"
                                    label="Terms_Description"
                                    track-by="Terms_Description"
                                    :preselect-first="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="modal-body text-center" v-else>
                            <i class="fa fa-spin fa-spinner text-grey-darkest vista-project-loader" aria-hidden="true"></i>
                            Fetching Spectrum Tax and Term Codes
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('spectrumTaxCodeSelectionModal')">Close</button>
                        <button type="button" class="btn btn-primary" :disabled="spectrumTaxCodes.length === 0 || spectrumTermsCodes.length === 0 || !selectedTermsCode || !selectedTaxCode" @click="closeModal('spectrumTaxCodeSelectionModal');connectCustomerToSpectrum()">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="selectCompanyContactForSpectrumModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Connect/Push</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('selectCompanyContactForSpectrumModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select contact to push to Spectrum</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="contacts"
                                    v-model="selectedCompanyContactForSpectrum"
                                    label="name"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div v-if="selectedCompanyContactForSpectrum && selectedCompanyContactForSpectrum.spectrum_customer_no" class="text-sm mb-3 text-green">The contact is synced already</div>
                        <div v-if="company.spectrum_customer_id && this.selectedCompanyContactForSpectrum && !selectedCompanyContactForSpectrum.spectrum_customer_no" class="text-sm text-danger">Note: This company is already synced with a Spectrum customer. Pushing a different contact will replace the Spectrum customer with the newly selected contact.</div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('selectCompanyContactForSpectrumModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pushCustomerToSpectrum" :disabled="!this.selectedCompanyContactForSpectrum || (this.selectedCompanyContactForSpectrum && this.selectedCompanyContactForSpectrum.spectrum_customer_no)">Push</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="updateSpectrumCustomerModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of an existing Spectrum Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{updateSpectrumModalBody}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('updateSpectrumCustomerModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateCustomerToSpectrum()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="syncSpectrumCustomerModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of an existing Spectrum Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this company and contact, with info form the synced Spectrum customer.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('syncSpectrumCustomerModal')">Cancel</button>
                        <button v-if="company.spectrum_customer_id" type="button" class="btn btn-primary" @click.prevent="syncContactFromSpectrum()">Confirm</button>
                        <button v-else type="button" class="btn btn-primary" @click.prevent="closeModal('syncSpectrumCustomerModal'); openModal('syncCompanyContactFromSpectrumModal')">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncCompanyContactFromSpectrumModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium" v-if="!syncFromSpectrumStepTwo">This company is not synced with a Spectrum Customer</h5>
                        <h5 class="modal-title text-teal font-medium" v-else>Select Followup contact</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('syncCompanyContactFromSpectrumModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row" v-if="!syncFromSpectrumStepTwo">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Spectrum customer to sync this company with</label>
                                <div v-if="fetchingSpectrumCustomers" class="spinner text-sm text-teal">
                                    Fetching customers from Spectrum...
                                </div>
                                <multiselect
                                    v-model="selectedSpectrumCustomer"
                                    :options="customersFromSpectrum"
                                    @search-change="onSyncSpectrumInput"
                                    label="name"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Spectrum customer..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncCompanyContactFromSpectrumModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedSpectrumCustomer" @click.prevent="() => syncFromSpectrumStepTwo = true">Next</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the contact you would like the Spectrum customer to be synced with</label>
                                <multiselect
                                    v-model="selectedFollowupContact"
                                    :options="contacts"
                                    label="name"
                                    track-by="id"
                                    :multiple="false"
                                    placeholder="Select Followup contact..."
                                    :closeOnSelect="true"
                                ></multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncCompanyContactFromSpectrumModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedFollowupContact || !selectedSpectrumCustomer" @click.prevent="saveSyncedSpectrumCustomer">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

export default {
    name: 'company-spectrum',
    components: {Multiselect},
    props: ['company', 'contacts', 'spectrumCompanyMapping', 'spectrumCustomerCodeCustomFieldId', 'canErpCreate', 'canErpUpdate', 'canErpSync'],
    data() {
        return {
            spectrumTaxCodes: [],
            spectrumTermsCodes: [],
            selectedTaxCode: null,
            selectedTermsCode: null,
            loadingSpectrumTaxCodes: false,
            updateSpectrumModalBody: '',
            selectedCompanyContactForSpectrum: null,
            spectrumLoading: false,
            selectedFollowupContact: null,
            selectedSpectrumCustomer: null,
            customersFromSpectrum: [],
            fetchingSpectrumCustomers: false,
            syncFromSpectrumStepTwo: false,
            customCustomerCode: null,
        }
    },
    created() {
        this.debouncedFilterOptions = _.debounce(this.filterOptions, 500);
        this.fetchSpectrumCodes();
    },
    methods: {
        syncSpectrumCompany() {
            if(this.spectrumCustomerCodeCustomFieldId && !this.customCustomerCode){
                this.customCustomerCode = this.$parent.$refs.CompanyCustomFields.form[this.spectrumCustomerCodeCustomFieldId] ?? null;
                if(!this.customCustomerCode){
                    this.getToast(3000).fire({type: 'error',title: 'Customer Code field is required'});
                }
            }else if(!this.spectrumCustomerCodeCustomFieldId || (this.spectrumCustomerCodeCustomFieldId && this.customCustomerCode)){
                this.openModal('spectrumTaxCodeSelectionModal')
            }
        },
        fetchSpectrumCodes(){
            let self = this;
            self.loadingSpectrumTaxCodes = true;
            axios.post(route('api.spectrum.get-spectrum-codes')).then((response) => {
                self.loadingSpectrumTaxCodes = false;
                self.spectrumTaxCodes = response.data.taxCodes;
                self.spectrumTermsCodes = response.data.termsCodes;
            });
        },
        openModal(modalId) {
            if(modalId === 'syncCompanyContactFromSpectrumModal'){
                this.syncFromVistaStepTwo = 0;
                this.selectedVistaCustomer = null;
                this.selectedFollowupContact = null;
            }
            $('#'+modalId).modal('show');
        },
        closeModal(modalId) {
            $('#'+modalId).modal('hide');
        },
        connectCustomerToSpectrum(){
            let self = this;
            if(self.company.spectrum_customer_id){
                self.updateSpectrumModalBody = 'This will replace some of the customer info on the Spectrum Customer record. Are you sure you want to update the customer on Spectrum?';
                self.openModal('updateSpectrumCustomerModal');
            }else{
                let payload = {'company': self.company, type: 'company'};
                self.spectrumLoading = true;
                axios.post(route('api.spectrum.connect-customer-on-spectrum'), payload).then((response) => {
                    self.spectrumLoading = false;

                    if(response.data.status == 'success'){
                        self.closeModal('spectrumTaxCodeSelectionModal');
                        self.getToast(3000).fire({type: 'success',title: response.data.message});
                        self.$parent.company.spectrum_customer_id = response.data.spectrum_customer_id;
                        self.$parent.fetchContacts();
                    }else{
                        // self.getToast().fire({type: 'error',title: response.data.message});
                        self.closeModal('spectrumTaxCodeSelectionModal');
                        self.openModal('selectCompanyContactForSpectrumModal');
                    }
                });
            }
        },
        pushCustomerToSpectrum() {
            let self = this;
            if(self.selectedCompanyContactForSpectrum && self.company.spectrum_customer_id){
                self.openModal('updateSpectrumCustomerModal');

            }else{
                let payload = {'company': self.company, 'contact': self.selectedCompanyContactForSpectrum, type: 'company', 'taxCodeId': this.selectedTaxCode.id, 'termsCode': this.selectedTermsCode.Terms_Description, customCustomerCode: self.customCustomerCode,  spectrumCustomerCodeCustomFieldId: self.spectrumCustomerCodeCustomFieldId};
                self.spectrumLoading = true;
                axios.post(route('api.spectrum.create-customer-on-spectrum'), payload).then((response) => {
                    self.spectrumLoading = false;
                    self.closeModal('selectCompanyContactForSpectrumModal');

                    if(response.data.status == 'success'){
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        self.$parent.company.spectrum_customer_id = response.data.spectrum_customer_id
                        self.selectedCompanyContactForSpectrum = null;

                        self.$parent.fetchContacts();

                    }else{
                        self.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
            }
        },
        updateCustomerToSpectrum() {
            let self = this;
            let contact = null;
            let pushingNewContact = false
            if(self.selectedCompanyContactForSpectrum){
                contact = self.selectedCompanyContactForSpectrum
                pushingNewContact = true;
            }else{
                contact = self.contacts.find(contact => contact.spectrum_customer_no !== null)
            }

            let payload = {'company': self.company, 'contact': contact, 'pushingNewContact': pushingNewContact,  type: 'company', customCustomerCode: self.customCustomerCode,  spectrumCustomerCodeCustomFieldId: self.spectrumCustomerCodeCustomFieldId};
            self.spectrumLoading = true;
            self.closeModal('updateSpectrumCustomerModal');
            self.closeModal('selectCompanyContactForSpectrumModal');
            axios.post(route('api.spectrum.update-customer-on-spectrum'), payload).then((response) => {

                self.spectrumLoading = false;
                self.selectedCompanyContactForSpectrum = null;

                if(response.data.status == 'success'){
                    self.getToast(3000).fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.$parent.fetchContacts();

                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        pushOtherContactToSpectrum(){
            let self = this;
            self.updateSpectrumModalBody = 'Are you sure you want to replace the existing Spectrum customer with the new contact?';
            self.openModal('selectCompanyContactForSpectrumModal')
        },
        onSyncSpectrumInput(value) {
            if (value.length >= 3) {
                this.fetchingSpectrumCustomers = true;
                this.debouncedFilterOptions(value);
            }
        },
        syncContactFromSpectrum(){
            let self = this;
            let checkAlreadySyncedContact = false;
            let syncedContact = null;

            self.contacts.forEach(item => {
                if(item.spectrum_customer_no){
                    checkAlreadySyncedContact = true;
                    syncedContact = item;
                }
            });
            if(checkAlreadySyncedContact && syncedContact){
                let payload = {
                    spectrumCustomer: null,
                    contact: syncedContact,
                    type: 'company'
                }
                self.spectrumLoading = true;
                axios.post(route('api.spectrum.sync-customers-from-spectrum'), payload).then((response) => {
                    self.closeModal('syncSpectrumCustomerModal');
                    self.spectrumLoading = false;
                    if(response.data.status == 'success'){
                        self.getToast(3000).fire({type: 'success',title: response.data.message});
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000);
                    }else{
                        self.getToast(2000).fire({type: 'error',title: response.data.message});
                    }
                });
            }

        },
        filterOptions(input) {
            let self = this;
            axios.post(route('api.spectrum.fetch-customers-from-spectrum'), {search: input}).then((response) => {
                self.fetchingSpectrumCustomers = false;
                if(response.data.status == 'success'){
                    self.customersFromSpectrum = response.data.spectrumCustomers;
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        saveSyncedSpectrumCustomer(){
            let self = this;
            let payload = {
                spectrumCustomer: self.selectedSpectrumCustomer,
                contact: self.selectedFollowupContact,
                type: 'company'
            }
            self.spectrumLoading = true;
            axios.post(route('api.spectrum.sync-customers-from-spectrum'), payload).then((response) => {
                self.closeModal('syncCompanyContactFromSpectrumModal');
                self.spectrumLoading = false;
                if(response.data.status == 'success'){
                    self.company.spectrum_customer_id = response.data.spectrum_customer_id
                    self.getToast(3000).fire({type: 'success',title: response.data.message});
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        pushOrUpdateCustomerToSpectrum(customerCode = null){
            this.customCustomerCode = customerCode;
            if(this.company.spectrum_customer_id){
                this.updateSpectrumModalBody = 'This will replace some of the customer info on the Spectrum Customer record. Are you sure you want to update the customer on Spectrum?';
                this.openModal('updateSpectrumCustomerModal');
            }else{
                this.selectedSpectrumCustomer = null;
                this.openModal('spectrumTaxCodeSelectionModal');
            }
        },
    }
}
</script>
